module.exports = __webpack_public_path__ + "video-processing.cfbccae86da2bd512949bb55d63c46a4.svg";